var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-box has-link",class:{
    'has-description': _vm.hasDescription,
    'has-description-in-image': _vm.descriptionInImage
  },on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-img',{staticClass:"image-box__image",attrs:{"src":_vm.src}},[_c('v-overlay',{attrs:{"absolute":"","opacity":_vm.opacity}},[(_vm.descriptionInImage && _vm.hasDescription)?[_c('h3',[_vm._t("description")],2)]:_vm._e()],2)],1),(!_vm.descriptionInImage && _vm.hasDescription)?_c('div',{staticClass:"image-box__description"},[_vm._t("description")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }